import { type LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import { getLocalePrefixFromLanguageRegionCode } from './languageTypeModifiers';
import { localizeUrlComponents } from './localizeUrlComponents';

/**
 * Converts a url to a localized url if the language region code is provided.
 *
 * Example: wrapUrlSafe('/trail/us/colorado/maxwell-falls-lower-trail', 'fr-FR') => '/fr/randonnee/us/colorado/maxwell-falls-lower-trail'
 * @param url - The url to wrap with a language prefix
 * @param languageRegionCode - The language region code to wrap the url with
 * @returns The url wrapped with a language prefix & localized path
 */
export function wrapUrlSafe(url: string, languageRegionCode: LanguageRegionCode): string {
  if (languageRegionCode) {
    const localePrefix = getLocalePrefixFromLanguageRegionCode(languageRegionCode);
    if (localePrefix) {
      return localizeUrlComponents(`/${localePrefix}${url}`, languageRegionCode);
    }
  }

  return url;
}

